export enum MainViewType {
  TimelineV1 = 'TimelineV1',
  TimelineV2 = 'TimelineV2', // not built yet
  FloorplanV2 = 'FloorplanV2',
  RunSheet = 'RunSheet'
}

export interface IMainView {
  name: string;
  view: MainViewType;
  tooltip: string;
  opened: boolean;
  icon: string;
}

const timelineV1: IMainView = {
  name: 'Diary',
  view: MainViewType.TimelineV1,
  tooltip: 'Diary',
  opened: false,
  icon: 'mdi-format-align-center'
};

const timelineV2: IMainView = {
  name: 'Timeline',
  view: MainViewType.TimelineV2,
  tooltip: 'Timeline',
  opened: false,
  icon: 'mdi-airplane'
};

const floorplanV2: IMainView = {
  name: 'Floor Plan',
  view: MainViewType.FloorplanV2,
  opened: false,
  tooltip: 'Floor Plan',
  icon: 'mdi-view-carousel'
};

const runSheet: IMainView = {
  name: 'Run Sheet',
  view: MainViewType.RunSheet,
  opened: false,
  tooltip: 'Run Sheet',
  icon: 'mdi-timetable'
};

export const MainViewConfigs = {
  timelineV1, timelineV2, floorplanV2, runSheet
}
